/** Demo content for the "Loan at Application" step. */
export const LoanAtApplication = () => {
    return <p>Loan at Application content goes here.</p>;
};
